import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule } from '@ngx-translate/core';
import { ChartsModule } from 'ng2-charts';
import { ButtonModule } from 'primeng/button';
import { CalendarModule } from 'primeng/calendar';
import { ContextMenuModule } from 'primeng/contextmenu';
import { DialogModule } from 'primeng/dialog';
import { DropdownModule } from 'primeng/dropdown';
import { InputTextModule } from 'primeng/inputtext';
import { MultiSelectModule } from 'primeng/multiselect';
import { ProgressBarModule } from 'primeng/progressbar';
import { SliderModule } from 'primeng/slider';
import { TableModule } from 'primeng/table';
import { ToastModule } from 'primeng/toast';
import { TreeTableModule } from 'primeng/treetable';
import { OsModule } from '../../rmpv/rmpv-detalhado-os/os.module';
import { ComumModule } from './../../../shared/comum.module';
import { FileUploadModule } from './../../../shared/fileupload/fileupload';
import { translateLoaderNBS } from './../../../shared/translate-loader/translateLoader';
import { ToolbarModule } from 'primeng/toolbar';
import { PanelModule } from 'primeng/panel';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { NgxFilesizeModule } from 'ngx-filesize';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { BadgeModule } from 'primeng/badge';
import { CadastrarFabricaListaComponent } from './cadastrar-fabrica-lista/cadastrar-fabrica-lista.component';
import { MessagesModule } from 'primeng/messages';
import { PaginatorModule } from 'primeng/paginator';
import { CheckboxModule } from 'primeng/checkbox';
import {InputSwitchModule} from 'primeng/inputswitch';


@NgModule({
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    TreeTableModule,
    TableModule,
    ToolbarModule,
    PanelModule,
    ConfirmDialogModule,
    NgxFilesizeModule,
    ProgressSpinnerModule,
    BadgeModule,
    ButtonModule,
    ToastModule,
    CalendarModule,
    SliderModule,
    MultiSelectModule,
    ContextMenuModule,
    DialogModule,
    DropdownModule,
    ProgressBarModule,
    InputTextModule,
    FormsModule,
    CommonModule,
    FileUploadModule,
    BrowserModule,
    ReactiveFormsModule,
    ComumModule,
    ChartsModule,
    MessagesModule,
    OsModule,
    NgbModule,
    TranslateModule.forRoot(translateLoaderNBS),
    PaginatorModule,
    CheckboxModule,
    InputSwitchModule
  ],
  exports: [
    CadastrarFabricaListaComponent,
  ],
  declarations: [
    CadastrarFabricaListaComponent,
  ],
providers: [
  ConfirmationService,
  MessageService,

]
})
export class CadastrarFabricaModule { }
